import { NotificationTypes } from "@/enums/notifications";
import type { JobStatus } from "@/enums/jobs";
import { getIdToken } from "@/services/Auth";
import { getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";

export async function createJob({
    baseUrl,
    body
}: {
    baseUrl: string;
    body: {
        type: (typeof NotificationTypes)[keyof typeof NotificationTypes];
        input: Record<string, unknown>;
    };
}) {
    const url = `${baseUrl}/v1/job/okta`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<{
        jobId: string;
        status: (typeof JobStatus)[keyof typeof JobStatus];
    }>(url, headers, "POST", body);
}
